var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "qg-toast" } },
    [
      _c("Localeselect"),
      _vm._v(" "),
      _c("Browserextension"),
      _vm._v(" "),
      !_vm.ignoreConsentToast ? _c("Consent") : _vm._e(),
      _vm._v(" "),
      _c("UnpublishedPage"),
      _vm._v(" "),
      _vm._l(_vm.displayToasts, function (toast) {
        return Array.isArray(_vm.displayToasts)
          ? [
              _c(toast, {
                tag: "Component",
                attrs: { data: _vm.toastData[toast] },
                on: { "dismiss-toast": _vm.dismissToast },
              }),
            ]
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }